// extracted by mini-css-extract-plugin
module.exports = {"orderList":"PrepaidItemSectionItemInfoBox-Jtails_orderList_144Gv"};